<div class="modal-container-content">
  <span>Je wachtwoord is succesvol gewijzigd.</span>
</div>

<div class="modal-container-footer">
  <app-button (click)="close()">Terug naar login</app-button>
</div>
